'use memo';

import React from 'react';
import {
  AgxNotificationBox,
  AgxSpacer,
} from '@urbanx/agx.ui-components2';
import LaunchDetailsProgress from './LaunchDetailsProgress';
import './LaunchDetails.scss';
import { useGetListingByCampaignId } from '@urbanx/agx.rex.client';
import { CampaignDetailModel } from '@urbanx/agx.campaigns.client';

interface LaunchDetailsProps {
  campaign: CampaignDetailModel;
}

const LaunchDetails: React.FC<LaunchDetailsProps> = ({ campaign }) => {

  const { data: rexListing, isPending: isRexListingPending } = useGetListingByCampaignId(campaign.campaignId ?? '');

  return (
    <>
      <AgxSpacer
        direction="vertical"
        id="launchDetailsWrapper"
        gap="lg"
      >
        {isRexListingPending ? null : (
          !rexListing ? (
            <AgxNotificationBox
              type="danger"
              heading=""
              body="Launch Pad is not available - Please contact your Admin Manager."
            />
          ) : (
            <LaunchDetailsProgress
              launchDetailsProgress={campaign?.campaignLaunchProgress}
            />
          )
        )}
      </AgxSpacer>
    </>
  );
};

export default LaunchDetails;
